import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';
@Injectable({
  providedIn: 'root'
})
export class MasterareaService {
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetGroup', data);
  }
  addArea(data: any): Observable<any[]> {
    //return this.http.post<any[]>(this.baseUrl + 'addmasterarea', data);
    return this.http.post<any[]>(this.O3CoreApiUrl + 'MasterArea/AddMasterArea', data);
  }

  //NOT IN USE
  // getAllAreaList(): Observable<any[]> {
  //   return this.http.get<any[]>(this.baseUrl + 'allmasterareas');
  // }

  deleteArea(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'MasterArea/DeleteMasterArea', data);
  }

  GetOneMasterArea(data: any): Observable<any> {
    // return this.http.post<any>(this.baseUrl + 'onemasterarea', data);
    return this.http.post<any>(this.O3CoreApiUrl + 'MasterArea/GetOneMasterArea				', data);
    
  }

  updateArea(data: any): Observable<any[]> {
    //return this.http.put<any[]>(this.baseUrl + 'masterarae', data);
    return this.http.put<any[]>(this.O3CoreApiUrl + ' MasterArea/UpdateMasterArea', data);
   
  }

  GetMasterArea(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Area/masterareabygroup', data);
    
  }
}
